import { Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField, Box, Button, CircularProgress, TextareaAutosize } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { loadJobTitle, loadYesNo } from "../../../../redux/actions/lookups.action";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import { axiosFetch } from "../../../../utils/AxiosFetch";
import { useNavigate } from "react-router";
import { NumericFormat } from 'react-number-format';
import { ConfirmationModal } from "../../../../shared";



function ManagerQuestion(props) {
    console.log(props);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [designationList, setDesignationList] = useState([]);
    const [yesnoList, setYesNoList] = useState([]);
    const [designation, setDesignation] = useState("")
    const [managerComments, setManagerComments] = useState("");
    const [hikepercent, setHikePercent] = useState("0");
    const [proposedCtc, setProposedCtc] = useState("0");
    const [nxtAppraisalDate, setNxtAppraisalDate] = useState("");
    const [jobTitleId, setJobTitleId] = useState(null);
    const [hikeError, setHikeError] = useState(false);
    const [ctcError, setCtcError] = useState(false);
    const [adminSubmitLoading, setAdminSubmitLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false)
    let LUJobTitle = useSelector(state => state.loadJobTitle_Reducer.jobTitleList);
    let LUYesNo = useSelector(state => state.loadYesNo_Reducer.yesnoList);
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";


    useEffect(() => {
        dispatch(loadJobTitle())
        dispatch(loadYesNo())
    }, [])

    useEffect(() => {
        if (LUJobTitle !== undefined) {
            setDesignationList(LUJobTitle)
            if (props.appraisal !== undefined && props.appraisal.proposedJobTitleId !== undefined && props.appraisal.proposedJobTitleId !== null) {
                LUJobTitle.filter((option) => {
                    if (props.appraisal.proposedJobTitleId.toString() === option.value) {
                        var value = []
                        value.push(option)
                        setDesignation(value)
                        setJobTitleId(props.appraisal.proposedJobTitleId)
                    }
                })
            }
        }
    }, [LUJobTitle, props.appraisal]);

    useEffect(() => {
        if (LUYesNo !== undefined) {
            setYesNoList(LUYesNo);
        }
    }, [LUYesNo])
    useEffect(() => {
        var extraValues = props.appraisal;
        if (extraValues !== undefined) {
            setManagerComments(extraValues.managerComments);
            setHikePercent(extraValues.proposedHike);
            setProposedCtc(extraValues.proposedCTC);
            if (extraValues.nextAppraisalDate && extraValues.nextAppraisalDate !== null) {
                // setNxtAppraisalDate(new Date(extraValues.nextAppraisalDate))
                setNxtAppraisalDate(moment(extraValues.nextAppraisalDate).format('MMM-DD-YYYY'))
            }
        }
    }, [props.appraisal])

    const handleCloseForm = () => {
        navigate('/annual-appraisal')
    }

    const handleConfirmationModal = () => {
        if (openConfirm) {
            setOpenConfirm(false)
        }
        else {
            setOpenConfirm(true)
        }
    }
    const handleFormSubmit = () => {
        if (props.profileDetail && props.profileDetail.reportingPersonEmpCode !== "0000" && isUserLogged.usertype !== "SuperAdmin" && isUserLogged.usertype !== "HRManager") {
            handleDraft(true, "no", "0")
        }
        else {
            handleDraft(true, "yes", "0")
        }
    }
    const handleDraft = (isSubmit, isAdmin, isConfirm) => {
        var questions = [];
        var objects;
        props.managerQuestion.filter(list => list.questionId === 7 && document.getElementById(list.questionId).value !== "").map((ques) => {
            var answers = document.getElementById(ques.questionId).value;
            objects = {
                "questionId": ques.questionId,
                "comments": document.getElementById(ques.questionId).value,
            }
            questions.push(objects)
        })
        var subQuestions = [];
        var subObjects;
        debugger;
        props.managerSubQuestion.filter(list => (document.getElementById("comment" + list.id).value !== "" || document.getElementById("yesno" + list.id).innerText !== "Select...")).map((subques) => {
            var checkYesNo = document.getElementById("yesno" + subques.id).innerText
            subObjects = {
                "questionId": subques.questionId,
                "subQuestionId": subques.id,
                "isYesNo": checkYesNo === "Yes" ? 1 : checkYesNo === "No" ? 2 : null,
                "comment": document.getElementById("comment" + subques.id).value
            }
            subQuestions.push(subObjects)
        })
        var ctcPerMonth = null;
        debugger;
        if (proposedCtc !== null && proposedCtc !== "") {
            if (proposedCtc.toString().includes(',')) {
                ctcPerMonth = proposedCtc.replace(/,/g, '');
            }
            else {
                ctcPerMonth = parseInt(proposedCtc);
            }
        }
        var req = {
            "id": parseInt(props.formId),
            "isSubmit": isSubmit,
            "review": {
                "ProposedHike": hikepercent,
                "ProposedCtc": ctcPerMonth,
                "ProposedJobTitleId": jobTitleId,
                "ManagerComments": managerComments,
                "NextAppraisalDate": null,
                // "NextAppraisalDate": nxtAppraisalDate !== null ? moment(nxtAppraisalDate) : null
            },
            "questions": questions.length > 0 ? questions : null,
            "subQuestions": subQuestions.length > 0 ? subQuestions : null
        }
        console.log(req)
        if (isSubmit === false) {
            if (hikeError === false
                && ctcError === false) {
                setLoading(true)
                handleUpdate(req, isSubmit, isAdmin)
            }
            else if (hikeError === true) {
                dispatch(SnackbarActions(true, "error", "Invalid Hike Percentage"));

            }
            else if (ctcError === true) {
                dispatch(SnackbarActions(true, "error", "Invalid gross value"));
            }

        }
        else if (isSubmit === true
            //&& ((hikepercent !== "" && hikepercent !== null && proposedCtc !== null && proposedCtc !== "") || jobTitleId !== null)
            && managerComments !== '' && managerComments !== null
            && hikeError === false
            && ctcError === false
            && props.managerQuestion.filter(list => list.questionId === 7 && document.getElementById(list.questionId).value !== "").length === props.managerQuestion.filter(list => list.questionId === 7).length
            && props.managerSubQuestion.filter(list => document.getElementById("comment" + list.id).value !== "").length === props.managerSubQuestion.length
            && props.managerSubQuestion.filter(list => document.getElementById("yesno" + list.id).innerText !== "Select...").length === props.managerSubQuestion.length
        ) {
            if (isConfirm === "1") {
                handleConfirmationModal();
                isSubmit = false;
            }
            else {
                if (isAdmin === "no") {
                    handleUpdate(req, isSubmit, isAdmin)
                    setSubmitLoading(true)
                }
                else {
                    handleUpdate(req, isSubmit, isAdmin)
                    setAdminSubmitLoading(true)
                }
                isSubmit = false;
            }
        }
        else {
            if (hikeError === true) {
                dispatch(SnackbarActions(true, "error", "Invalid Hike Percentage"));

            }
            if (ctcError === true) {
                dispatch(SnackbarActions(true, "error", "Invalid gross value"));
            }
            else {
                dispatch(SnackbarActions(true, "warning", "Please fill out all review questions"));

            }
        }
    }
    const handleUpdate = (req, isSubmit, isAdmin) => {
        axiosFetch({
            method: "post",
            url: `/Performance/appraisal/subquestions`,
            requestConfig: req

        })
            .then((res) => {
                if (res.status === 200) {
                    props.loadQuestions();
                    // if (isAdmin === "yes") {
                    //     managerUpdate(isSubmit)
                    // }
                    // else {
                    dispatch(SnackbarActions(true, "success", "Your response has been updated successfully"));

                    // }

                    setSubmitLoading(false)
                    setLoading(false)
                    setTimeout(() => {
                        navigate(`/annual-appraisal`);
                    }, 4000)
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    setSubmitLoading(false)
                    setLoading(false)
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }
    const handleHike = (e) => {
        // var regexp =/^[0-9]*[.][0-9]+$/;
        var regexp = /^\d+(\.\d{1,2})?$/;
        if (e.target.value !== "") {
            if (regexp.test(e.target.value)) {
                setHikeError(false)
                setHikePercent(e.target.value)
            }
            else {
                setHikeError(true)
                setHikePercent(e.target.value)
            }
        }
        else {
            setHikeError(false)
            setHikePercent(e.target.value)
        }
    }
    const handleCTC = (e) => {
        var regexp = /^(([0-9](,)?)*)+$/;
        if (regexp.test(e.target.value)) {
            setCtcError(false)
            setProposedCtc(e.target.value);
        }
        else {
            setCtcError(true)
            setProposedCtc(e.target.value)
        }
    }
    const handleDesignation = (selected) => {
        setDesignation(selected)
        setJobTitleId(selected.value)
    }
    const handleDate = (date) => {
        setNxtAppraisalDate(date)
    }

    const managerUpdate = (isSubmit) => {

        axiosFetch({
            method: "post",
            url: `/Performance/appraisal/update`,
            requestConfig: {
                "id": parseInt(props.formId),
                "isSubmit": true
            }

        })
            .then((res) => {
                if (res.status === 200) {
                    setAdminSubmitLoading(false)

                    dispatch(SnackbarActions(true, "success", "Your response has been updated successfully"));


                }
                else if (res.status === 400) {
                    setAdminSubmitLoading(false)

                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }
    var date = moment().toDate();

    const minValue = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    const maxValue = (date.getFullYear() + 1) + "-" + (date.getMonth() + 1) + "-" + date.getDate();

    console.log(date, minValue)
    return (
        <div>
            <Grid container>
                {props.managerQuestion.length > 0 ?
                    props.managerQuestion.map((list) => {
                        return (
                            <Grid item xs={12} className="argus-qa">
                                <p className="questions">{list.question}</p>
                                {list.questionId !== 8 ? <Box
                                    component="form"
                                    className="answers"
                                    sx={{
                                        '& > :not(style)': { marginBottom: 2 },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >

                                    <TextareaAutosize
                                        fullWidth
                                        id={list.questionId}
                                        // multiline
                                        maxRows={4}
                                        className="argus-answers"
                                        variant="outlined"
                                        defaultValue={(props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "" : list.comments}
                                        disabled={(props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                    />
                                </Box> : <></>}
                            </Grid>
                        )
                    })
                    : <></>}
                <Grid xs={12}>
                    <Table className="score-table left-table">
                        <TableHead className="dark-head">
                            <TableCell></TableCell>
                            <TableCell>About the Team Member</TableCell>
                            <TableCell>Yes / No</TableCell>
                            <TableCell>Comments</TableCell>
                        </TableHead>
                        {props.managerSubQuestion.length > 0 ?
                            props.managerSubQuestion.map((list) => {
                                return (

                                    <TableBody className="pmp-table-body">
                                        <TableRow>
                                            <TableCell>{list.id}</TableCell>
                                            <TableCell>{list.subQuestion}</TableCell>
                                            <TableCell>{(props.reportingManagerId !== isUserLogged.userid) && (props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "—" :
                                                <Select
                                                    id={"yesno" + list.id}
                                                    options={yesnoList}
                                                    isDisabled={((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                                    defaultValue={list.isYesNo !== null ? yesnoList.filter(option => option.label === list.isYesNo) : list.isYesNo}
                                                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        control: base => ({
                                                            ...base,

                                                            minWidth: 110,
                                                            borderRadius: '3px',
                                                            fontSize: '14px',
                                                            textAlign: 'left',
                                                        })
                                                    }} />}</TableCell>
                                            <TableCell>
                                                {(props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "—" :
                                                    <TextField multiline defaultValue={list.comments} id={"comment" + list.id} size="small"
                                                        disabled={(props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                                        maxRows={4} sx={{ width: '90ch' }} style={{ backgroundColor: "white" }} name="comment" placeholder="Comments" />}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>


                                )
                            }) : <></>}
                    </Table>
                </Grid>
                <Grid xs={12} sx={{ marginTop: "20px" }}>
                    <h2 className="pmp-headings">Notes on Any Changes to Team Member Status</h2>
                    <Table className="score-table argus-table left-table">
                        <TableBody>
                            <TableRow>
                                <TableCell>Recommended Hike %</TableCell>
                                <TableCell>
                                    {(props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "—" :
                                        <TextField value={hikepercent} fullWidth onChange={(e) => handleHike(e)}
                                            inputProps={{ maxLength: 6 }}
                                            //disabled={(props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                            disabled={true}
                                            error={hikeError}
                                            helperText={hikeError ? "Invalid hike percentage" : ""} />}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Current Gross [Per Month] of Team Member</TableCell>
                                <TableCell>
                                    {props.appraisal.currentCTC !== null ?
                                        // <NumericFormat placeholder="Proposed Gross" className="textarea-input desc-okr"
                                        //     thousandSeparator={true}
                                        //     value={props.appraisal.currentCTC}
                                        //     disabled={true} />
                                        "—"
                                        : "—"}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Revised Gross [Per Month] of Team Member</TableCell>
                                <TableCell>
                                    {(props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "—" :

                                        <NumericFormat placeholder="Proposed Gross" className="textarea-input desc-okr"
                                            thousandSeparator={true}
                                            value={proposedCtc}
                                            onChange={(e) => handleCTC(e)}
                                            // disabled={(props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                            disabled={true}
                                        />}

                                    <span className="error-message">{ctcError ? "Please fill out valid gross" : ""}</span>
                                    {/* <TextField value={proposedCtc} fullWidth onChange={(e) => handleCTC(e)}
                                        disabled={props.appraisal.statusName !== "Manager Review" || (props.reportingManagerId !== isUserLogged.userid)}
                                        error={ctcError}
                                        helperText={ctcError ? "Invalid CTC " : ""} /> */}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Current Designation </TableCell>
                                <TableCell>
                                    {props.appraisal.currentJobTitle !== null ? props.appraisal.currentJobTitle : ""}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Recommended Designation</TableCell>
                                <TableCell>
                                    {(props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "—" :

                                        <Select
                                            menuPortalTarget={document.body} menuPosition={'fixed'}
                                            isDisabled={(props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            }}
                                            placeholder="Select Designation"
                                            name="Designation"
                                            value={designation}
                                            options={designationList}
                                            onChange={(selected) => handleDesignation(selected)}
                                        />}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Next Appraisal Date</TableCell>
                                <TableCell>
                                    {(props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "—" :

                                        <TextField fullWidth value={nxtAppraisalDate}
                                            disabled={true}
                                            // InputProps={{ inputProps: { min: minValue, max: maxValue } }}
                                            label="Next Appraisal Date"
                                        // onChange={(e) => handleDate(e.target.value)}
                                        />

                                        // <DatePicker
                                        //     disabled={(props.appraisal.statusName !== "Re Assign" && props.appraisal.statusName !== "Manager Review") || (props.reportingManagerId !== isUserLogged.userid)}
                                        //     minDate={moment().toDate()}
                                        //     // value = {nxtAppraisalDate}
                                        //     placeholderText="Next Appraisal Date"
                                        //     selected={nxtAppraisalDate}
                                        //     onChange={(date) => handleDate(date)}
                                        //     dateFormat="MMM-dd-yyyy"
                                        //     className="datetime"
                                        // />
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <br />

                        <p >If there is a Pay raise and/or designation change, please explain the rationale and any details behind the change:</p>


                        <TextareaAutosize
                            id="filled-multiline-flexible"
                            multiline
                            maxRows={4}
                            variant="filled"
                            fullWidth
                            value={
                                (props.reportingManagerId !== isUserLogged.userid) && ((props.appraisal.statusId === 7 && props.appraisal.userId === isUserLogged.userid) || props.appraisal.statusId === 4 || props.appraisal.statusName === "Manager Review" || (props.appraisal.statusId === 3 && isUserLogged.userid === props.appraisal.userId)) ? "" :
                                    managerComments}
                            className="argus-answers-comments"
                            onChange={(e) => setManagerComments(e.target.value)}
                            disabled={(props.appraisal.statusId !== 4 && props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                        />
                    </Grid>
                </Grid>
                {parseInt(props.reportingManagerId) === parseInt(isUserLogged.userid) ?
                    <Grid container xs={12} sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
                        {loading ?
                            <CircularProgress size='2rem' sx={{ marginRight: "10px" }} /> :
                            <Button variant="contained" className="theme-btn cancel-btn" disabled={submitLoading || (props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 4 && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)} sx={{ marginRight: "10px" }}
                                onClick={() => handleDraft(false, "no")}
                            >Save As Draft
                            </Button>
                        }
                        {
                            props.profileDetail && props.profileDetail.reportingPersonEmpCode !== "0000" && isUserLogged.usertype !== "SuperAdmin" && isUserLogged.usertype !== "HRManager" ?
                                submitLoading ?
                                    <CircularProgress size='2rem' sx={{ marginRight: "10px" }} /> :
                                    <Button variant="contained" className="theme-btn" disabled={loading || (props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 4 && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                        onClick={() => handleDraft(true, "no", "1")}
                                    >Submit</Button>
                                :
                                adminSubmitLoading ?
                                    <CircularProgress size='2rem' sx={{ marginRight: "10px" }} /> :
                                    <Button variant="contained" className="theme-btn" disabled={loading || (props.appraisal.statusName !== "Manager Review" && props.appraisal.statusId !== 4 && props.appraisal.statusId !== 7) || (props.reportingManagerId !== isUserLogged.userid)}
                                        onClick={() =>
                                            handleDraft(true, "yes", "1")
                                        }
                                    >Submit</Button>
                        }
                    </Grid>
                    :
                    <Grid container xs={12} sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
                        {props.appraisal.statusId !== 5 && props.appraisal.statusId !== 6 ? <Button variant="outlined" className="theme-btn cancel-btn" onClick={handleCloseForm}>Close</Button> : ""}
                    </Grid>
                }
            </Grid>
            <ConfirmationModal open={openConfirm} handleClose={handleConfirmationModal} message={"You cannot edit the form after submitting it. Are you sure you want to submit the form?"} handleYes={handleFormSubmit} />

        </div>
    )
}

export default ManagerQuestion;